export const MiniSitesRouter = [
  {
    path: '/minisites/:organizator',
    name: 'Ministite',
    component: () => import('../../views/minisites/Index'),
  }
];